(() => {
  const root = document.querySelector('.vm-curated');
  if (!root) return;
  const tabs = [...root.querySelectorAll('[role="tab"]')];
  const activate = (tab, focus = false) => {
    tabs.forEach((item) => {
      const active = item === tab;
      item.setAttribute('aria-selected', String(active));
      item.tabIndex = active ? 0 : -1;
      const panel = document.getElementById(item.getAttribute('aria-controls'));
      if (panel) panel.hidden = !active;
    });
    if (focus) tab.focus();
  };
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => activate(tab));
    tab.addEventListener('keydown', (event) => {
      const next = event.key === 'ArrowRight' ? index + 1 : event.key === 'ArrowLeft' ? index - 1 : null;
      if (next === null) return;
      event.preventDefault();
      activate(tabs[(next + tabs.length) % tabs.length], true);
    });
  });
})();

